import React, { lazy } from 'react';
import { XCircle } from 'lucide-react';
const problems = ['Fines de semana buscando información en internet que nunca aplica exactamente a tu situación', 'Albañiles que te dan tres precios distintos y no sabés a cuál creerle', 'Empezaste la obra y en el camino aparecieron gastos que nadie te avisó', 'El Cómputo de materiales, el hormigón armado, la instalación eléctrica — sin guía práctica en tu idioma', 'Distintas etapas sin saber en qué orden construir para no desperdiciar plata', 'Fin de semana agotado, el lunes volvés a empezar el mismo ciclo de dudas'];
export function ProblemSection() {
  return <section className="bg-charcoal text-white pt-0 pb-[27px]" data-id="element-267">
      <div className="rounded-b-xl overflow-hidden" data-id="element-268">
        <img src="https://cdn.magicpatterns.com/uploads/qkQSZaRnnKvPUw2cFq9CQ1/Feed.png" alt="Colección Arquitectura Argentina" className="w-full object-cover object-center" loading="lazy" decoding="async" data-id="element-269" />
      </div>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-6" data-id="element-270">
        <p className="text-center text-gold font-semibold text-lg mb-1 uppercase tracking-wider" data-id="element-271">
          Guía práctica para construir con criterio
        </p>
        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-center" data-id="element-272">
          ¿Te sentís identificado con algo de esto?
        </h2>

        <div className="space-y-5 text-lg text-gray-300 mb-12 max-w-2xl mx-auto" data-id="element-273">
          <p className="flex items-start gap-3" data-id="element-274">
            <span className="text-gold text-xl mt-0.5" data-id="element-275">→</span>
            ¿No sabés por dónde empezar con tu casa?
          </p>
          <p className="flex items-start gap-3" data-id="element-276">
            <span className="text-gold text-xl mt-0.5" data-id="element-277">→</span>
            ¿Te preocupa gastar de más en errores que podrías evitar?
          </p>
          <p className="flex items-start gap-3" data-id="element-278">
            <span className="text-gold text-xl mt-0.5" data-id="element-279">→</span>
            ¿Sentís que dependés demasiado de terceros para tomar decisiones?
          </p>
          <p className="flex items-start gap-3" data-id="element-280">
            <span className="text-gold text-xl mt-0.5" data-id="element-281">→</span>
            ¿Pasás fines de semana buscando información que nunca aplica a tu
            caso?
          </p>
          <p className="mt-6 font-semibold text-gold text-center text-xl" data-id="element-282">
            No es falta de ganas. Es falta de un sistema claro.
          </p>
        </div>

        <div className="bg-white/5 border border-white/10 rounded-xl p-6 md:p-8 space-y-4" data-id="element-283">
          {problems.map((problem, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-284">
              <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-0.5" data-id="element-285" />
              <p className="text-gray-200" data-id="element-286">{problem}</p>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-287">
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-gold italic" data-id="element-288">
            ¿Y si este fuera el último fin de semana que pasás así?
          </h3>
        </div>
      </div>
    </section>;
}